module.exports = __webpack_public_path__ + "static/media/Puma_Female_Left_low.d172b633.jpg";